import React from "react";



export default function Onetime() {
    return (
        <div className="onetime-container my-4">
            {/* Header */}
            <div className="special-header panel-white-all">
                <h4 className="header-onetime page-title">One time</h4>
            </div>
            {/* Table */}
            <div className="card col-md-12">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="custom-table p-10 table-bordered mb-0">
                            <tbody>
                                <tr>

                                    <td style={{ width: "500px" }}>Fee Frequency ID</td>
                                    <td>1</td>

                                </tr>
                                <tr>

                                    <td>Fee Frequency Name</td>
                                    <td>One time</td>

                                </tr>
                                <tr>

                                    <td>Fee Frequency Status</td>
                                    <td>Active</td>

                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>

    );

}